import { Box, Flex, Text, Grid, GridItem, Image as ChakraImage } from '@chakra-ui/react';
import { Heading } from 'elements';
import { useState } from 'react';

type Image = {
  url: string;
};

type LoadMoreImagesProps = {
  images: Image[];
  title: string;
  subtitle: string;
};

const LoadMoreImages = ({ title, subtitle, images }: LoadMoreImagesProps) => {
  const [showMore, setShowMore] = useState(false);
  const onShowMore = () => setShowMore(!showMore);

  return (
    <Flex flexDirection='column'>
      <Heading title={title} color='black' fontWeight={700} />
      <Heading title={subtitle} color='grey' fontSize='md' />

      <Grid
        templateRows='repeat(auto, 1fr)'
        templateColumns={[
          'repeat(1, auto)',
          'repeat(2, 1fr)',
          'repeat(4, 1fr)']}
        gap={4}>

        {images.slice(0, (showMore ? undefined : 6)).map((image, i, array) => (
          <GridItem
            rowSpan={1}
            colSpan={[1, 1, 1, i % 3 === 0 ? 2 : 1]}
            width='100%'
            height='100%'
          >
            <ChakraImage borderRadius='25px'
              objectFit='cover'
              width='100%' height='100%'
              src={image.url} alt='Image of location'
            />
            {i === array.length - 1 && !showMore &&
              <Flex
                width='100%'
                height='100%'
              >
                <Box
                  display='flex'
                  justifyContent='center'
                  flexDirection='column'
                  backgroundColor='rgba(18, 17, 17, 0.6)'
                  width='100%'
                  height='100%'
                  position='relative'
                  bottom={'100%'}
                  zIndex={3}
                  borderRadius='25px'
                >
                  <Text alignSelf='center' cursor='pointer' fontSize='20px' onClick={onShowMore} color='white'>
                    {`+ ${images.length - 5
                      } Photos`}
                  </Text>
                </Box>
              </Flex>}
          </GridItem>
        ))}

      </Grid>

    </Flex>
  );
};

export { LoadMoreImages };
